<div class="list-block-questions-item">
  <div class="list-block-questions-item__header">
    <div class="eiq-id-badge small">
      <fa-icon [icon]="blockTypeConfig[block$().type].icon"></fa-icon>
      <span>{{ block$().id }}</span>
    </div>
    <span class="list-block-questions-item__header-title fs__sm fw__500">{{ block$().title }}</span>
  </div>
  @if (isParentBlock$()) {
    @if (childBlockViews$().length) {
      @for (childBlockView of childBlockViews$(); track childBlockView.block.id) {
        <empathy-list-block-questions-item
          [blockView]="childBlockView"
          [activeQuestionId]="activeQuestionId()"
          (activate)="activate.emit($event)"
          (removePage)="removePage.emit($event)"
        />
      }
    } @else {
      @for (childBlock of childBlocks$(); track childBlock.id) {
        <empathy-list-block-questions-item
          [block]="childBlock"
          [activeQuestionId]="activeQuestionId()"
          (activate)="activate.emit($event)"
          (removePage)="removePage.emit($event)"
        />
      }
    }
  } @else {
    <div class="list-block-questions-item__list">
      @for (bq of questionsInBlock$(); track bq.question.id) {
        @if (bq.showPageBreak) {
          <div class="list-block-questions-item__page remove">
            <button
              mat-icon-button
              matTooltip="Delete Page"
              [attr.data-testid]="'list-block-delete-page-' + bq.question.pageId + '-button'"
              (click)="removePage.emit(bq.question.pageId)"
            >
              <fa-icon [icon]="faClose"></fa-icon>
            </button>
            <mat-divider></mat-divider>
          </div>
        }
        <div class="list-block-questions-item__list-row">
          <empathy-list-question-item
            [active]="bq.question.id === activeQuestionId()"
            [isFirst]="bq.isFirst"
            [isLast]="bq.isLast"
            [movePositionAllowed]="bq.movePositionAllowed"
            [question]="bq.question"
            (activate)="activate.emit($event)"
          ></empathy-list-question-item>
        </div>
      }
    </div>
  }
</div>
